export default __webpack_public_path__ + "static/media/logo.6dfb38e4.svg";